import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// « Agir en tant que » — messaging, password and group pages stay closed
export default function NotWhileActingAs({ children }) {
  const { user } = useAuth();
  if (user?.act_as) return <Navigate to="/dashboard" replace />;
  return children;
}
